import React from 'react'

import { SHIPMENT_STATUS, SHIPMENT_STATUS_LABEL } from 'constants/Shipment'

import styles from './ShipmentStatusChip.module.css'

const STATUS_CHIP_CLASS: Record<number, string> = {
  [SHIPMENT_STATUS.PreDelivery]: styles.chipPreDelivery,
  [SHIPMENT_STATUS.Delivering]: styles.chipDelivering,
  [SHIPMENT_STATUS.Completed]: styles.chipCompleted,
}

type Props = {
  status: 0 | 1 | 2
}

export const ShipmentStatusChip: React.FC<Props> = ({ status }) => (
  <span className={`${styles.statusChip} ${STATUS_CHIP_CLASS[status] ?? ''}`.trim()}>
    {SHIPMENT_STATUS_LABEL[status] ?? ''}
  </span>
)
